export default __webpack_public_path__ + "adf365f2313b5d8125146bcdc793bbd6.svg";